import { Injectable } from '@angular/core';
import { APP_Constants } from 'src/app/app.constant';
import { Observable, Subject } from 'rxjs';
import { of } from "rxjs";

@Injectable({ providedIn: 'root' })
export class SearchBoxDataService  {

    constructor() {

     }
    //  search(term: string): Observable<any[]> {  
    //     var ClientList = this.http.get(this.endPoint + '?term=' + term)  
    //         .map((r: Response) => { return (r.json().length != 0 ? r.json() : [{ "ClientId": 0, "ClientName": "No Record Found" }]) as any[] });  
    //     return ClientList;  
    // } 
     public search(term: any): Observable<any[]>
     {
         return of([  
            {  
                "Id": 11,  
                "Value": "Sacramento, CA"  
            },  
            {  
                "Id": 12,  
                "Value": "San Bernardino, CA"  
            },  
            {  
                "Id": 13,  
                "Value": "Rincon San Francisco Delivery Services"  
            },  
            {  
                "Id": 24,  
                "Value": "2000550799- Sakar Healthcare Inc"  
            },  
            {  
                "Id": 27,  
                "Value": "2000040000- Salzar Global Co Inc"  
            },  
            {  
                "Id": 28,  
                "Value": "Sanofi Logistic Services & Supply Ltd"  
            }  
        ] )
     }
}